<template>
  <div
    :class="the_class"
  >
    <div class="promopopup-top" >
      <h3 class="promopopup__title">{{title}}</h3>
      <button class="promopopup__close" @click="close()"></button>
    </div>
    <div class="promopopup-bottom">
      <div class="promopopup-bottom-left">
        <img
          v-if="image"
          :src="image"
          :alt="title || 'Promotion image'"
        >
      </div>
      <div class="promopopup-bottom-right">
        <p v-if="content" class="promopopup__content">
          {{content}}
        </p>
        <p v-if="details" class="promopopup__details">
          {{details}}
        </p>
        <button @click="addToCart()">Add to cart</button>
      </div>

    </div>
  </div>

</template>

<script>
import globalTheme from 'Assets/js/components/globalTheme';
import events from "Assets/js/components/events";
import { mapGetters } from "vuex";

export default {
  name: "PromoPopup",
  data() {
    return {
      active: false,
      image: '',
      title: '',
      content: null,
      details: null,
      shopifycode: '',
      addProduct: '',
      promoId: null,
      _updateToken: 0
    }
  },
  computed: {
    ...mapGetters([
      'cartInstance'
    ]),
    the_class(){
      if(this.active && this.addProduct != '' ){
        return 'promopopup promopopup--show'
      }
      return 'promopopup promopopup--hide'
    },
  },
  methods: {
    addToCart(){
      if( this.addProduct !== '' ){
        globalTheme.varientIdByProductId(this.addProduct).then((data) => {
          this.cartInstance.addToCart(data, 1, this.addProduct, () => {
            events.cartChange();
            if(this.shopifycode === '') {
              this.close('cta');
            } else {
              this.cartInstance.addPromoCodeToCart(this.shopifycode, () => {
                events.cartChange();
                this.close('cta');
              });
            }
          });
        });
      }
    },
    trackPromoAction(action = 'close') {
      try {
        const payload = {
          event: 'promo_popup',
          promo_action: action,
          promo_id: this.promoId || '',
          promo_title: this.title || ''
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (e) {
        // no-op
      }
    },
    close(action = 'close'){
      if (this.adding) {
        return;
      }
      this.trackPromoAction(action);
      // Set a per-promo cookie to suppress only this promo in future
      if (this.promoId) {
        document.cookie = `STYXKEY_no_promos_pls_${this.promoId}=1;-1; path=/`;
      }

      this.active = !this.active;
    },
  },
  mounted() {

    const inlineImagePath = (value) => {
      if (!value && value !== 0) {
        return '';
      }
      if (typeof value !== 'string') {
        return '';
      }
      const trimmed = value.trim();
      if (!trimmed) {
        return '';
      }
      if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) {
        return trimmed;
      }
      if (/[\\/]/.test(trimmed) && !/^\d+$/.test(trimmed)) {
        return trimmed;
      }
      return '';
    };

    async function getImage(image) {
      const fetchById = async (id) => {
        const numericId = Number(id);
        if (!Number.isFinite(numericId)) {
          return '';
        }

        const response = await fetch('/wp-json/wp/v2/media/' + numericId);
        if (!response.ok) {
          return '';
        }
        const data = await response.json();
        return data?.source_url || '';
      };

      const isDirectPath = (value) => {
        if (typeof value !== 'string') {
          return false;
        }
        const trimmedValue = value.trim();
        if (trimmedValue === '') {
          return false;
        }
        if (/^https?:\/\//i.test(trimmedValue) || trimmedValue.startsWith('/')) {
          return true;
        }
        const hasPathCharacters = /[\\/]/.test(trimmedValue) && !/^\d+$/.test(trimmedValue);
        return hasPathCharacters;
      };

      const fromObject = (source) => {
        if (!source || typeof source !== 'object') {
          return '';
        }

        if (isDirectPath(source.url)) {
          return source.url.trim();
        }

        if (isDirectPath(source.source_url)) {
          return source.source_url.trim();
        }

        if (isDirectPath(source.guid?.rendered)) {
          return source.guid.rendered.trim();
        }

        if (source?.sizes && typeof source.sizes === 'object') {
          const sizeCandidates = Object.values(source.sizes || {});
          const urlFromSizes = sizeCandidates.find((candidate) => isDirectPath(candidate));
          if (urlFromSizes) {
            return urlFromSizes.trim();
          }
        }

        const possibleId = source.ID ?? source.id ?? source.media_id ?? source.mediaId;
        const numericFromObject = Number(possibleId);
        if (Number.isFinite(numericFromObject)) {
          return numericFromObject;
        }

        return '';
      };

      if (Array.isArray(image)) {
        const firstValue = image.find((value) => !!value);
        if (firstValue) {
          return getImage(firstValue);
        }
        return '';
      }

      if (image === null || image === undefined || image === '') {
        return '';
      }

      if (typeof image === 'object') {
        const resolved = fromObject(image);
        if (typeof resolved === 'string' && resolved !== '') {
          return resolved;
        }
        if (Number.isFinite(resolved)) {
          return fetchById(resolved);
        }
        return '';
      }

      const trimmed = typeof image === 'string' ? image.trim() : image;
      if (typeof trimmed === 'string') {
        if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
          try {
            const parsed = JSON.parse(trimmed);
            return getImage(parsed);
          } catch (e) {
            // noop, fall through to other handling
          }
        }

        const inlineResolved = inlineImagePath(trimmed);
        if (inlineResolved) {
          return inlineResolved;
        }
        return fetchById(trimmed);
      }

      if (typeof trimmed === 'number') {
        return fetchById(trimmed);
      }

      return '';
    }

    function split(input, part) {
      const parts = input.split("||");
      return parts[part];
    }

    const applyPromo = async (pid, promoDetails) => {
      // Generate a token to guard against async race conditions when multiple promos fire
      const token = ++this._updateToken;
      const content = (promoDetails && promoDetails.content) || {};
      const add = (promoDetails && promoDetails.add) || '';
      const code = (promoDetails && promoDetails.code) || '';

      // Reset previous state first to avoid visual mix-ups
      this.image = '';
      this.title = '';
      this.content = null;
      this.details = null;
      this.addProduct = '';

      // Apply synchronous fields immediately so the popup can show fast
      this.promoId = pid || null;
      this.title = content.title || '';
      this.addProduct = split(add, 0) || '';
      this.content = content.content || null;
      this.details = content.details || null;
      this.shopifycode = code || '';
      this.active = true;

      const inlineResolvedImage = inlineImagePath(content.image);
      if (inlineResolvedImage) {
        this.image = inlineResolvedImage;
        return;
      }

      // Resolve image asynchronously and avoid stale updates
      try {
        if (content.image) {
          const imageUrl = await getImage(content.image);
          if (token === this._updateToken) {
            this.image = imageUrl || '';
          }
        }
      } catch (e) {
        if (token === this._updateToken) {
          this.image = '';
        }
      }
    };

    window.addEventListener('promo-toggled', async (event) => {
      const pid = event.detail?.promoId ? String(event.detail.promoId) : null;
      const details = event.detail?.promoDetails || {};
      applyPromo(pid, details);
    })

    // Fallback for test promo deep link if event dispatch races the mount
    try {
      const params = new URLSearchParams(window.location.search || '');
      const testId = params.get('test_promo');
      if (testId) {
        const allDetails = (globalTheme && globalTheme.promotionDetails && globalTheme.promotionDetails()) || {};
        const details = allDetails[testId];
        if (details) {
          applyPromo(String(testId), details);
        }
      }
    } catch (e) {}
},
}
</script>
